import { lazy, Suspense } from 'react';

import { LoadingScreen } from '@/components/feedback/loading-screen';

const PresalesServiceTypeListPage = lazy(() =>
  import('@pages/settings/accounts/presales-service-types/list').then((m) => ({
    default: m.PresalesServiceTypeListPage,
  }))
);

const PresalesServiceTypeCreatePage = lazy(() =>
  import('@pages/settings/accounts/presales-service-types/create').then((m) => ({
    default: m.PresalesServiceTypeCreatePage,
  }))
);

const PresalesServiceTypeEditPage = lazy(() =>
  import('@pages/settings/accounts/presales-service-types/edit').then((m) => ({
    default: m.PresalesServiceTypeEditPage,
  }))
);

export const presalesServiceTypesSettingsRoutes = [
  {
    path: 'presales-service-types',
    children: [
      {
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesServiceTypeListPage />
          </Suspense>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesServiceTypeListPage />
          </Suspense>
        ),
      },
      {
        path: 'new',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesServiceTypeCreatePage />
          </Suspense>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <PresalesServiceTypeEditPage />
          </Suspense>
        ),
      },
    ],
  },
];
